export default {"src":"/_next/static/media/search.5b36dd9b.svg","height":18,"width":18};